import { useEffect, useState } from 'react'

const selector = '.header-content-bg'

export function useScrollActive(maxScroll = 0) {
    const [scrollActive, setScrollActive] = useState(false)
    const setScroll = (topValue) => {
        const contentContainer = document.querySelector(selector) 
        contentContainer.scrollTo({top: topValue, behavior: 'smooth'})
    }

    useEffect(() => {
        const contentContainer = document.querySelector(selector)
        const onScroll = () => {
            setScrollActive(contentContainer.scrollTop >= maxScroll)
            return contentContainer.scrollTop
        }
        contentContainer.addEventListener('scroll', onScroll, { passive: true })
        return () => contentContainer.removeEventListener('scroll', onScroll)
    }, [])

    return [scrollActive, setScroll]
}

export default useScrollActive;
